import { Box, Stack, Tooltip, Typography } from "@mui/material";
import { useContext, useState } from "react";
import { AppContext } from "./../../lib/Context";
import moment from "moment";

const ContractEvent = ({ event }) => {
  const [open, setOpen] = useState(false);
  const { userData } = useContext(AppContext);

  const toggleTooltip = (value) => {
    if (!value) {
      setTimeout(() => setOpen(false), 150);
    } else {
      setOpen(true);
    }
  };

  const commonTextStyle = {
    fontSize: "0.85rem",
    fontFamily: "Roboto",
    lineHeight: 1.6,
    color: "#333",
  };

  const renderInsideView = () => (
    <Stack
      // direction="row"
      // alignItems="center"
      // justifyContent="space-between"
      onMouseEnter={() => toggleTooltip(true)}
      onMouseLeave={() => toggleTooltip(false)}
      onTouchStart={() => toggleTooltip(true)}
      sx={{
        borderRadius: "6px",
        cursor: "pointer",
      }}
    >
      <Typography lineHeight={1} fontSize={"0.85rem"} fontWeight={600} noWrap>
        {event?.title}
      </Typography>
      <Typography lineHeight={1} fontSize={"0.75rem"} noWrap>
        {event?.businessName}
      </Typography>
    </Stack>
  );

  const renderTooltipView = () => (
    <Box>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        p={1}
        bgcolor={"primary.main"}
        color={"white"}
      >
        <Typography fontSize="0.9rem" fontWeight={600}>
          📋 Details {event?.isReminder ? "(Reminder)" : null}
        </Typography>
      </Stack>

      <Stack p={2} spacing={1.2}>
        {userData?.designation === "Admin" && (
          <Typography {...commonTextStyle}>
            <strong>Agent:</strong> {event?.agentName}
          </Typography>
        )}

        <Typography {...commonTextStyle}>
          <strong>Name:</strong> {event?.title}
        </Typography>
        <Typography {...commonTextStyle}>
          <strong>Business:</strong> {event?.businessName}
        </Typography>

        <Typography {...commonTextStyle}>
          <strong>Contact:</strong> {event?.contact}
        </Typography>
        <Typography {...commonTextStyle}>
          <strong>Address:</strong> {event?.address}
        </Typography>
        {event?.isReminder && (
          <Typography {...commonTextStyle}>
            <strong>Set Live Date:</strong>{" "}
            {moment(event?.actualData).format("DD.MM.YY")}
          </Typography>
        )}
      </Stack>
    </Box>
  );

  return (
    <Tooltip
      open={open}
      title={renderTooltipView()}
      onClose={() => toggleTooltip(false)}
      onOpen={() => toggleTooltip(true)}
      disableHoverListener
      disableTouchListener
      placement="top"
      PopperProps={{
        sx: {
          zIndex: 1500,
          "& .MuiTooltip-tooltip": {
            padding: "0px",
            color: "#000000",
            backgroundColor: "#ffffff",
            border: "1px solid #ddd",
            boxShadow: "0px 4px 12px rgba(0,0,0,0.15)",
            borderRadius: "8px",
            overflow: "hidden",
            minWidth: "320px",
            maxWidth: "420px",
          },
        },
      }}
    >
      <Box>{renderInsideView()}</Box>
    </Tooltip>
  );
};

export default ContractEvent;
